import React from "react"

export const YouTube = props => (
  <svg width={27} height={19} {...props}>
    <path
      d="M11 13V5l7 4-7 4zM26.436 2.967a3.393 3.393 0 0 0-2.387-2.4C21.944 0 13.501 0 13.501 0S5.056 0 2.95.567a3.393 3.393 0 0 0-2.387 2.4C0 5.085 0 9.501 0 9.501s0 4.417.564 6.533a3.395 3.395 0 0 0 2.387 2.4C5.056 19 13.501 19 13.501 19s8.443 0 10.548-.566a3.395 3.395 0 0 0 2.387-2.4C27 13.918 27 9.501 27 9.501s0-4.416-.564-6.534z"
      fill="#FFF"
      fillRule="evenodd"
    />
  </svg>
)
